import React, { Suspense, lazy } from 'react'
import { Row, useOverlay } from '@fs/zion-ui'
import CompareAction, { OtherActions } from './CompareAction'

const DeleteOverlay = lazy(() => import('./DeleteOverlay'))

export default function GenealogyActions({ tree }) {
  const deleteOverlay = useOverlay()
  return (
    <>
      <Row guttersX="md" guttersY="nano" alignX="end">
        <CompareAction type="button" tree={tree} enableDisabled flexBox />
        <OtherActions type="button" tree={tree} onDeleteClick={deleteOverlay.handleClick} flexBox />
      </Row>
      <Suspense fallback="">
        {(deleteOverlay.isOpen || deleteOverlay.transitioning) && <DeleteOverlay overlay={deleteOverlay} tree={tree} />}
      </Suspense>
    </>
  )
}
